<template>
  <div v-if="list && list.length > 0" :id="selector" class="glideClass" ref="glide">
    <div class="glide__track glide-track" data-glide-el="track">
      <ul class="glide__slides">
        <li v-for="(item,index) in list" :key="index" class="glide__slide">
          <CatalogItem :item="item" class="catalog-card"/>
        </li>
      </ul>
    </div>
    <div class="glide__arrows" data-glide-el="controls">
      <button class="glide__arrow glide__arrow--left" data-glide-dir="<">
        <i class="ni ni-bold-left text-main-color"></i></button>
      <button class="glide__arrow glide__arrow--right" data-glide-dir=">">
        <i class="ni ni-bold-right text-main-color"></i>
      </button>
    </div>
  </div>
</template>

<script>
import Glide from '@glidejs/glide'
import CatalogItem from "@/views/components/elements/CatalogItem";
import {generateUuidNo} from "@/util/helpers";

export default {
  name: "CatalogGlide",
  components: {
    CatalogItem: CatalogItem,
  },
  props: {
    list: Array,
  },
  data() {
    return {
      is_init: false,
      selector: "",
      glide: null,
    };
  },
  created() {
    const randomNum = generateUuidNo();
    this.selector = `glide_${randomNum}`;
  },
  watch: {
    list: {
      immediate: true,
      handler(val) {
        if (Array.isArray(val) && val.length > 0) {
          this.$nextTick(() => {
            if (!this.glide) this.mountGlide();
          });
        } else {
          if (this.glide) this.destroyGlide();
        }
      }
    }
  },
  methods: {
    mountGlide() {
      this.glide = new Glide(`#${this.selector}`, {
        type: 'carousel',
        startAt: 0,
        perView: 4,
        perMove: 1,
        autoplay: 12000,
        hoverpause: true,
        animationDuration: 500,
        breakpoints: {
          1199: {
            perView: 3,
          },
          991: {
            perView: 2,
          },
          767: {
            perView: 1,
          },
        },
      });
      this.glide.mount();
    },
    destroyGlide() {
      if (this.glide) {
        try {
          this.glide.destroy();
        } catch (e) {
          // ignore
        }
        this.glide = null;
      }
    },
  },
  beforeDestroy() {
    this.destroyGlide();
  },
}
</script>

<style lang="scss" scoped>
.fit {
  object-fit: cover;
}

.glideClass {
  position: relative;
  padding: 0 2.5rem;
  box-sizing: border-box;
}

.glide-track {
  padding: 0;
  box-sizing: border-box;
}

.glide__slide {
  display: flex;
  justify-content: center;
}

.catalog-card {
  width: 220px;
  flex: 0 0 auto;
}

.glide__arrows {
  pointer-events: none;
}

.glide__arrow {
  pointer-events: auto;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
}

.glide__arrow--left {
  left: 0.25rem;
}

.glide__arrow--right {
  right: 0.25rem;
}

@media (max-width: 991px) {
  .glideClass {
    padding: 0 1rem;
  }
}

@media (max-width: 575px) {
  .glideClass {
    padding: 0 0.5rem;
  }
}
</style>
